import { formatThousands } from '../../../utils/format/formatNumber';
import { COMPARE_TEXT_MAP } from './getReportContent';

export const getCompareResult = (current, previous, unit, dateType, current2, previous2) => {
    let state = 'neutral'; // 'increased', 'decreased', 'neutral'
    let compareDescription = '';
    let currentValue = current2 ? current + current2 : current;
    let previousValue = previous2 ? previous + previous2 : previous;

    if (previous === null || dateType === 'custom') {
        return { compareDescription: null, state: null };
    }

    if (previousValue === currentValue) {
        compareDescription = `${COMPARE_TEXT_MAP[dateType]} 대비 동일`;
    }
    if (previousValue < currentValue) {
        state = 'increased';
        const formattedValue = formatThousands(currentValue - previousValue, unit);
        compareDescription = `${COMPARE_TEXT_MAP[dateType]} 대비 ${formattedValue} 증가`;
    }
    if (previousValue > currentValue) {
        state = 'decreased';
        const formattedValue = formatThousands(previousValue - currentValue, unit);
        compareDescription = `${COMPARE_TEXT_MAP[dateType]} 대비 ${formattedValue} 감소`;
    }

    return { compareDescription, state };
};
